import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data || !props.documentId) return data

    let documentId = !isNaN(Number(props.documentId))
      ? Number(props.documentId)
      : props.documentId
    return { ...data, document_id: documentId }
  }, [data, props.documentId])
}
